import { Route, Switch } from "react-router-dom";

import Layout from "@/containers/Layout";
import { ROUTES } from "@/routes_new";

import { MentionsViewInner } from "../MentionsView";
import { OrgRedirectView } from "../OrgRedirectView";
import Empty from "./empty";

const ArchiveView: React.FunctionComponent = () => {
  return (
    <Layout>
      <Switch>
        <Route path={ROUTES.ARCHIVE_DETAIL} component={OrgRedirectView} />
        <Route path={ROUTES.ARCHIVE_DETAIL_ORGID}>
          <MentionsViewInner url={ROUTES.ARCHIVE_DETAIL_ORGID} />
        </Route>
        <Route path={ROUTES.ARCHIVE} component={OrgRedirectView} />
        <Route path={ROUTES.ARCHIVE_ORGID} component={Empty} />
      </Switch>
    </Layout>
  );
};

export default ArchiveView;
